module.exports = __webpack_public_path__ + "img/loginback.fccd36b5.png";